export default "0ad26e336736d297.svg"